export default {
  focusOffset: '1px',
  focusStyle: 'solid',
  focusBorderWidth: '2px',
};
